import { UpdateCampaignForm } from './update-campaign-form'

export const UpdateCampaign = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <UpdateCampaignForm onCloseModal={onCloseModal} />
}
